/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { X } from 'lucide-react';

/* Import i18n functions */
import { useI18n } from '@/context/I18nContext';

interface DemoSelectedSensorTargetsProps {
    onRemove: (target: string) => void;
    targets: string[];
}

function DemoSelectedSensorTargets({ onRemove, targets }: DemoSelectedSensorTargetsProps) {
    const { t } = useI18n();

    return (
        <section className="dashboard-panel flex items-stretch justify-start p-5">
            <div className="w-full rounded-box bg-base-200/60 px-3 py-2">
                <h2 className="text-xs font-semibold uppercase tracking-[0.08em] text-base-content/60">
                    {t('Selected sensors')}
                </h2>
                {targets.length > 0 ? (
                    <ul className="mt-2 flex list-none flex-wrap gap-2 p-0">
                        {targets.map((target) => (
                            <li key={target} className="inline-flex max-w-full items-center gap-3 rounded-box border border-base-300 bg-base-100 px-3 py-2">
                                <span className="break-all font-mono text-sm">{target}</span>
                                <button
                                    type="button"
                                    className="btn btn-ghost btn-xs"
                                    onClick={() => onRemove(target)}
                                    aria-label={t('Remove sensor')}
                                    title={t('Remove sensor')}
                                >
                                    <X className="h-4 w-4" aria-hidden="true" />
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : <p className="mt-2 text-sm">{t('No sensors selected yet.')}</p>}
            </div>
        </section>
    );
}

export default DemoSelectedSensorTargets;
